module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bh-avatar-upload",
    style: ({
      width: _vm.width + 'px',
      height: _vm.width * _vm.ratio + 'px'
    })
  }, [(_vm.disabled) ? _c('img', {
    style: ({
      width: _vm.width + 'px',
      height: _vm.width * _vm.ratio + 'px',
      borderRadius: _vm.radius + 'px'
    }),
    attrs: {
      "src": _vm.imgUrl
    }
  }) : _c('a', {
    staticClass: "bh-btn bh-btn-default bh-emapAvatar-upload",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('img', {
    staticClass: "bh-emapAvatar-avatar",
    style: ({
      width: _vm.width + 'px',
      height: _vm.width * _vm.ratio + 'px',
      borderRadius: _vm.radius + 'px'
    }),
    attrs: {
      "src": _vm.imgUrl
    }
  }), _vm._v(" "), _c('input', {
    style: ({
      width: _vm.width + 'px',
      height: _vm.width * _vm.ratio + 'px'
    }),
    attrs: {
      "type": "file"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectorShow),
      expression: "selectorShow"
    }],
    staticClass: "select-container mt-bg-lv2",
    style: ({
      height: (_vm.clientHeight) + 'px'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('img', {
    staticClass: "bh-avatar-img"
  }), _vm._v(" "), _c('div', {
    staticClass: "avatar-buttons",
    style: ({
      bottom: _vm.bottomPosition
    })
  }, [_c('mt-button', {
    staticClass: "avatar-button",
    attrs: {
      "size": "large",
      "type": "default"
    },
    on: {
      "click": _vm.actionGoback
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('mt-button', {
    staticClass: "avatar-button",
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": _vm.actionCut
    }
  }, [_vm._v("裁剪")])], 1)])])], 1)
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./src/components/emapm-avatar-upload.vue